import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadoPreventaEnum,
  gridSizeMdLg12,
  ModulosEnumChoice,
  newMotivoPreventaCorporativaSchema,
  TABLE_CONSTANTS,
} from "@/shared";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import { CustomAutocomplete, CustomTextArea } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import {
  FormMotivoRechazoPreventaCorporativa,
  MotivoRechazo,
} from "@/shared/interfaces";
import { yupResolver } from "@hookform/resolvers/yup";
import { Restore, Visibility } from "@mui/icons-material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared";
import { useState } from "react";
import { useForm } from "react-hook-form";
// import { TiposTextFieldNumberEnum } from '@/shared/components/ui/CustomTextFieldNumberComponente';
import {
  fetchGetPreventasCorporativos,
  fetchPutPreventaCorporativo,
} from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import InfoCoordendas from "@/shared/components/ui/InfoCoordendas/InfoCoordendas";
import { IPreventaCorporativo } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { useUiStore } from "@/store/ui";
import useColumnsOportunidadComercial from "../columns/useColumnsOportunidadComercial";

interface TableGestionOportunidadComercialProps {
  showCustomActionBtnSpace?: boolean;
  enableEditing?: boolean;
  estado_preventa?: string;
  // aprueba_plan_personalizado?: boolean
}

export default function TableGestionOportunidadComercial({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  estado_preventa = "EN GESTION",
}: // aprueba_plan_personalizado
TableGestionOportunidadComercialProps) {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventacoorporativa,
    PermissionsEnum.api_change_preventacoorporativa,
  ]);

  const navigate = useNavigate();
  const [modalCancelar, setModalCancelar] = useState(false);
  const setconfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  ///* Form
  const formRechazo = useForm<FormMotivoRechazoPreventaCorporativa>({
    resolver: yupResolver(newMotivoPreventaCorporativaSchema),
  });

  const { reset: resetRechazar } = formRechazo;

  const { columnsPreventaCorporativo } = useColumnsOportunidadComercial();

  const { pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;
  ///* Fetch
  const { mutateAsync: updatePreventaCorporativo } =
    fetchPutPreventaCorporativo({
      enableSuccessAlert: true,
    });

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.PREVENTA_CORPORATIVO,
    page_size: 100,
  });

  const {
    isLoading,
    data: factibilidadCorporativos,
    isRefetching,
  } = fetchGetPreventasCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    filterByState: false,
    estado_preventa: estado_preventa,
    ...filterObject,
    // aprueba_plan_personalizado: aprueba_plan_personalizado,
  });

  const handleGestionOportunidadComercial = (id_preventa_coorporativa: string, state: string) => {
    updatePreventaCorporativo({
      id_preventa_coorporativa: id_preventa_coorporativa,
      estado_preventa: state as EstadoPreventaEnum,
    });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaCorporativo>
            columns={columnsPreventaCorporativo}
            data={factibilidadCorporativos?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={factibilidadCorporativos?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // // actions
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn="first"
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            customActionBtnSpace={(selectedRow) => {
              return (
                <Grid container {...gridSizeMdLg12}>
                  <Grid item>
                    <Tooltip title={"Ver Pre-Factibilidad"} placement="top">
                      <IconButton
                        onClick={() => {
                          navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/${selectedRow?.id_preventa_coorporativa}`);
                        }}
                      >
                        <Visibility />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title={"Reversar"} placement="top">
                      <IconButton
                        onClick={() => {
                          setconfirmDialog({
                            isOpen: true,
                            title: "Reversar",
                            subtitle: "¿Estás seguro de reversar esta Oportunidad Comercial?",
                            onConfirm: () => {
                              handleGestionOportunidadComercial(
                                selectedRow?.id_preventa_coorporativa!,
                                EstadoPreventaEnum.EN_ESPERA
                              );
                              setConfirmDialogIsOpen(false);
                            },
                            onClose: () => {
                              setConfirmDialogIsOpen(false);
                            }
                          });

                        }}
                      >
                        <Restore/>
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title={"Cancelar"} placement="top">
                      <IconButton
                        onClick={() => {
                          setconfirmDialog({
                            isOpen: true,
                            title: "Cancelar",
                            subtitle: "¿Estás seguro de cancelar esta Oportunidad Comercial?",
                            onConfirm: () => {
                              handleGestionOportunidadComercial(
                                selectedRow?.id_preventa_coorporativa!,
                                EstadoPreventaEnum.CANCELADO
                              );
                              setConfirmDialogIsOpen(false);
                            },
                            onClose: () => {
                              setConfirmDialogIsOpen(false);
                            }
                          });
                        }}
                      >
                        <HighlightOffIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            }}
          />
        </Grid>
      </Grid>

      {/*Modal para cancelar*/}

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás a punto de cancelar una preventa del cliente ${
            formRechazo.getValues().razon_social
          }
          con la identificación ${
            formRechazo.getValues().identificacion
          }. ¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  "El motivo de rechazo es requerido"
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues().observacion_cancelacion ?? ""
                }
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={
                  formRechazo.formState.errors.observacion_cancelacion?.message
                }
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (form) => {
            const resp = await updatePreventaCorporativo({
              id_preventa_coorporativa: form.id_preventa_corporativa,
              estado_preventa: EstadoPreventaEnum.CANCELADO,
              motivo_rechazo: form.motivo_rechazo,
              observaciones: {
                ...form.observaciones,
                observacion_cancelar: form.observacion_cancelacion,
              },
              observacion_rechazo: [
                {
                  motivo: formRechazo.getValues().motivo_rechazo,
                  observacion: formRechazo.getValues().observacion_cancelacion,
                  fecha: new Date().toISOString(),
                },
              ],
            });
            if (resp.code === 200) {
              resetRechazar({});
              setModalCancelar(false);
              //window.location.reload()
            }
          })}
          onClose={() => {
            resetRechazar({});
            setModalCancelar(false);
          }}
        />
      )}

      <InfoCoordendas />
    </>
  );
}
